<template>
  <div class="container">
    <Header/>
    <section class="content">
      <div class="title-box">
        <h1>{{ pageTitle }}</h1>
        <div v-html="pageDescription" class="page-description"></div>
      </div>
    </section>
    <Footer/>
  </div>
</template>

<script>
import Header from '@/components/General/AppHeader.vue';
import Footer from '@/components/General/AppFooter.vue';
import {retrievePage} from "@/services/apiService";

export default {
  name: "LeafPage",
  components: {
    Header,
    Footer,
  },
  data() {
    return {
      pageTitle: 'Professioni verdi e rinverdite',
      pageDescription: '',
      error: null,
    };
  },
  mounted() {
    this.loadPage();
  },
  methods: {
    async loadPage() {
      try {
        const pageData = await retrievePage('LeafPage');
        this.renderPage(pageData);
      } catch (error) {
        console.error('Error loading page:', error);
        this.error = 'Failed to load page data. Please try again later.';
      }
    },
    renderPage(pageData) {
      this.pageTitle = pageData.attributes.title;
      this.pageDescription = pageData.attributes.description;
    }
  }
}
</script>

<style scoped>

</style>
